import { useContext } from 'react'

import Button from '@/components/view/atoms/button/Button'
import AreaContent from '@/components/view/layouts/area/AreaContent'
import Modal, { ModalType } from '@/components/view/layouts/modal/Modal'
import ModalContent, { ModalContentType } from '@/components/view/layouts/modal/ModalContent'
import ModalFooter from '@/components/view/molecules/modal/ModalFooter'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import { WidgetCssModalContext } from './WidgetCssModalProvider'

interface WidgetCssModalInnerProps {
  customCss: string
}

const WidgetCssModalInner = ({ customCss }: WidgetCssModalInnerProps) => {
  return (
    <ModalContent type={ModalContentType.FLEX_GROW}>
      <AreaContent>
        <pre className='m-0 max-h-100 overflow-auto rounded-lg border border-slate-200/50 bg-slate-100/60 px-4 py-3 font-mono text-xs whitespace-pre-wrap text-slate-800'>
          {customCss}
        </pre>
      </AreaContent>
    </ModalContent>
  )
}

const WidgetCssModal = () => {
  const { modal, showing, hide } = useContext(WidgetCssModalContext)

  return (
    <Modal show={showing} type={ModalType.LARGE}>
      <ModalHeader text={'カスタムCSS'} onClickClose={hide} />
      {modal.showing && <WidgetCssModalInner customCss={modal.customCss} />}
      <ModalFooter>
        <Button color={'secondary'} size={'large'} onClick={hide}>
          閉じる
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default WidgetCssModal
